module.exports = __webpack_public_path__ + "media/images/goldoni-ea07a4b59e87cb519648b08b7f1f490b.png";